export default __webpack_public_path__ + "navigation-examples-custom-voice-controller-thumbnail-960-bfb9aec9f8ed0b39b0159e54a6a6dcb7.webp";